import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { TemplateFieldDto } from '../../../admin/templates/templates-admin.model';
import { User } from '../../../../models/user.model';
import { FieldValueChange } from '../dynamic-field.component';
import { FieldTypeStrategy, FieldValidationResult } from './field-type-strategy.interface';

/**
 * Abstract base class for all field type strategy components.
 * Provides common inputs, outputs, and helper methods.
 *
 * Extend this class to create a new field type strategy.
 */
@Directive()
export abstract class BaseFieldComponent implements FieldTypeStrategy {
    @Input() field!: TemplateFieldDto;
    @Input() value: any;
    @Input() users: User[] = [];
    @Input() readonly: boolean = false;
    @Output() valueChange = new EventEmitter<FieldValueChange>();

    /**
     * Initialize the field with its current value.
     * Override to handle type-specific initialization.
     */
    abstract initialize(value: any): void;

    /**
     * Serialize the current value for API submission.
     * Override for type-specific serialization.
     */
    abstract serialize(): any;

    /**
     * Optional validation. Override if the field type needs validation.
     */
    validate?(): FieldValidationResult;

    /**
     * Helper to check if field is required.
     */
    get isRequired(): boolean {
        return this.field?.required || false;
    }

    /**
     * Emit a value change event.
     * Call this when the field value changes.
     */
    protected emitChange(newValue: any): void {
        this.value = newValue;
        this.valueChange.emit({
            fieldKey: this.field.fieldKey,
            value: newValue
        });
    }
}
